import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { FormatType } from "../models/EbayOffer";
import { DefaultResponseWithData } from "../models/system";

export interface IVehicleCategoryPart {
  id: string;
  tagNumber: string | null;
  title: string | null;
  titleSanitised: string | null;
  price: number | null;
  enteredPrice: number | null;
  soldDate: string | null;
  created: string;
  isInternal: boolean;
  margin: number | null;
  cdnThumbnail: string | null;
  importThumbnail: string | null;
  ebayItemNumber: string | null;
  ebayTradingApiItemId: string | null;
  ebayInventoryApiOfferId: string | null;
  oePartNumber: string | null;
  partNumber: string | null;
  vehicleId: string | null;
  vehicleCombinedMake: string | null;
  vehicleCombinedModel: string | null;
  vehicleVrm: string | null;
  vehicleEngineModelCode: string | null;
  vehicleDVLAYearOfManufacture: number | null;
  thumbnailImageUrl: string | null;
  images: IVehicleCategoryPartImage[];
  offers: IVehicleCategoryPartOffer[];
}

export interface IVehicleCategoryPartImage {
  id: string;
  url: string;
  thumbnailUrl: string;
  isThumbnail: boolean;
}

export interface IVehicleCategoryPartOffer {
  format: FormatType;
  buyItNowPrice: number | null;
  auctionStartPrice: number | null;
}

export interface IVehicleCategoryPartsResponse extends DefaultResponseWithData<IVehicleCategoryPart[]> { }

export default function useVehicleCategoryPartsOptimized(
  vehicleId: string | undefined,
  categoryId: string | undefined,
  includeSold: boolean = true,
  limitSold?: number
) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60 * 60; // 60 minutes

  const parts = useQuery({
    queryKey: ["vehicleCategoryParts", vehicleId, categoryId, includeSold, limitSold],
    queryFn: () => {
      const params = new URLSearchParams();
      if (includeSold !== undefined) params.append("includeSold", includeSold.toString());
      if (limitSold !== undefined) params.append("limitSold", limitSold.toString());
      const queryString = params.toString();
      return get<IVehicleCategoryPartsResponse>(
        `/part/vehicle/${vehicleId}/part-categories/${categoryId}/parts${queryString ? `?${queryString}` : ""}`
      );
    },
    enabled: !!vehicleId && !!categoryId,
    staleTime: staleTime,
  });

  return {
    parts
  };
}
